/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type FilterQueryContent_QueryVariables = {
    projectId?: string | null | undefined;
    groupId?: string | null | undefined;
    programPrefix?: string | null | undefined;
    fetchAllProjectPhases: boolean;
};
export type FilterQueryContent_QueryResponse = {
    readonly viewer: {
        readonly actualPersonId: string | null;
        readonly component: string | null;
        readonly " $fragmentRefs": FragmentRefs<"FilterQueryContent_viewer">;
    } | null;
};
export type FilterQueryContent_Query = {
    readonly response: FilterQueryContent_QueryResponse;
    readonly variables: FilterQueryContent_QueryVariables;
};



/*
query FilterQueryContent_Query(
  $projectId: ID
  $groupId: String
  $programPrefix: String
  $fetchAllProjectPhases: Boolean!
) {
  viewer {
    actualPersonId
    component(name: "new_filter")
    ...FilterQueryContent_viewer_ThpMZ
    id
  }
}

fragment AllPhasesDropdown_phases on PhaseTypeEdge {
  node {
    id
    name
    projectId
  }
}

fragment AllPhasesDropdown_projects on ProjectTypeEdge {
  node {
    id
    name
    projectColor
    companyProjectId
    status
  }
}

fragment ClientDropdown_clients on ClientTypeEdge {
  node {
    id
    name
    logoId
  }
}

fragment DepartmentDropdown_departments on DepartmentTypeEdge {
  node {
    id
    name
  }
}

fragment DeprecatedProjectIndicatorJS_project on ProjectType {
  name
  companyProjectId
  customProjectId
  projectColor
}

fragment FilterQueryContent_viewer_ThpMZ on Viewer {
  client {
    id
  }
  availableFeatureFlags {
    key
    id
  }
  projects(first: 1000000, excludeRestricted: true) {
    edges {
      ...ProjectDropdown_projects
      ...ProjectContactDropdown_projects
      ...AllPhasesDropdown_projects @include(if: $fetchAllProjectPhases)
      node {
        id
        name
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  phases @include(if: $fetchAllProjectPhases) {
    edges {
      ...AllPhasesDropdown_phases @include(if: $fetchAllProjectPhases)
      node {
        id
        name
        projectId
      }
    }
  }
  project(internalId: $projectId) {
    demo
    statusColumnsV2(first: 1000000) {
      edges {
        ...ProjectStatusColumnDropdown_columns
        node {
          id
          name
          __typename
        }
        cursor
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
    projectPersons(first: 1000000) {
      edges {
        ...ProjectPersonDropdown_persons
        node {
          person {
            id
            initials
            firstName
            lastName
            profilePictureId
            profilePictureDefaultId
          }
          id
          __typename
        }
        cursor
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
    phases(first: 1000000) {
      edges {
        ...PhasesDropdown_phases
        node {
          id
          name
          __typename
        }
        cursor
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
    sprints(first: 1000000) {
      edges {
        ...SprintDropdown_sprints
        node {
          id
          name
          __typename
        }
        cursor
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
    id
  }
  projectGroup(id: $groupId) {
    projects(first: 1000000) {
      edges {
        ...ProjectDropdown_projects
        node {
          id
          name
          companyProjectId
          statusColumnsV2(first: 1000000) {
            edges {
              ...ProjectStatusColumnDropdown_columns
              node {
                id
                name
                projectGroupStatusColumnId
                __typename
              }
              cursor
            }
            pageInfo {
              endCursor
              hasNextPage
            }
          }
          projectPersons(first: 1000000) {
            edges {
              ...ProjectPersonDropdown_persons
              node {
                person {
                  id
                  firstName
                  lastName
                }
                id
                __typename
              }
              cursor
            }
            pageInfo {
              endCursor
              hasNextPage
            }
          }
          phases(first: 1000000) {
            edges {
              ...PhasesDropdown_phases
              node {
                id
                name
                __typename
              }
              cursor
            }
            pageInfo {
              endCursor
              hasNextPage
            }
          }
          sprints(first: 1000000) {
            edges {
              ...SprintDropdown_sprints
              node {
                id
                name
                projectGroupSprintId
                __typename
              }
              cursor
            }
            pageInfo {
              endCursor
              hasNextPage
            }
          }
          __typename
        }
        cursor
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
    id
  }
  program(prefix: $programPrefix) {
    projects(first: 1000000) {
      edges {
        node {
          serviceCompanyId
          legacyProject {
            edges {
              ...ProjectDropdown_projects
              node {
                id
                name
                companyProjectId
                statusColumnsV2(first: 1000000) {
                  edges {
                    ...ProjectStatusColumnDropdown_columns
                    node {
                      id
                      name
                      projectGroupStatusColumnId
                      __typename
                    }
                    cursor
                  }
                  pageInfo {
                    endCursor
                    hasNextPage
                  }
                }
                projectPersons(first: 1000000) {
                  edges {
                    ...ProjectPersonDropdown_persons
                    node {
                      person {
                        id
                        firstName
                        lastName
                      }
                      id
                      __typename
                    }
                    cursor
                  }
                  pageInfo {
                    endCursor
                    hasNextPage
                  }
                }
                phases(first: 1000000) {
                  edges {
                    ...PhasesDropdown_phases
                    node {
                      id
                      name
                      __typename
                    }
                    cursor
                  }
                  pageInfo {
                    endCursor
                    hasNextPage
                  }
                }
                sprints(first: 1000000) {
                  edges {
                    ...SprintDropdown_sprints
                    node {
                      id
                      name
                      projectGroupSprintId
                      __typename
                    }
                    cursor
                  }
                  pageInfo {
                    endCursor
                    hasNextPage
                  }
                }
              }
            }
          }
          id
          __typename
        }
        cursor
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
    id
  }
  company {
    skillLevelsEnabled
    skillLevels {
      id
      level
      description
    }
    ...SkillDropdown_company
    skills(first: 10000) {
      edges {
        node {
          id
          name
          __typename
        }
        cursor
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
    ...SkillLevelDropdown_company
    modules {
      moduleType
      id
    }
    rateCards(first: 1000000) {
      edges {
        ...RateCardDropdown_rateCards
        node {
          id
          name
          __typename
        }
        cursor
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
    allPersons(first: 1000000) {
      edges {
        ...PersonDropdown_persons
        node {
          id
          firstName
          lastName
          __typename
        }
        cursor
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
    teams(first: 1000000) {
      edges {
        ...TeamDropdown_teams
        node {
          id
          name
          teamPersons(first: 1000) {
            edges {
              node {
                id
                person {
                  id
                }
                __typename
              }
              cursor
            }
            pageInfo {
              endCursor
              hasNextPage
            }
          }
          __typename
        }
        cursor
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
    clients(first: 1000000) {
      edges {
        ...ClientDropdown_clients
        node {
          id
          name
          __typename
        }
        cursor
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
    labels(first: 1000000) {
      edges {
        node {
          id
          name
          category {
            id
            name
            allowOnPeople
            allowOnProjects
            allowOnTasks
          }
          ...LabelDropdownJS_labels
          __typename
        }
        cursor
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
    roles(first: 1000000) {
      edges {
        ...RoleDropdown_roles
        node {
          id
          name
          __typename
        }
        cursor
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
    idleTimes(first: 1000000) {
      edges {
        ...IdleTimeDropdown_idleTimes
        node {
          id
          name
          __typename
        }
        cursor
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
    departments(first: 100000) {
      edges {
        ...DepartmentDropdown_departments
        node {
          id
          name
        }
      }
    }
    priorityLevels(first: 1000) {
      edges {
        node {
          id
          name
          weight
        }
      }
    }
    programs(first: 100000) {
      edges {
        node {
          id
          name
        }
      }
    }
    billFroms {
      id
      name
      integration
      billTos(first: 10000) {
        edges {
          node {
            id
            name
            __typename
          }
          cursor
        }
        pageInfo {
          endCursor
          hasNextPage
        }
      }
    }
    expenseCategories(first: 10000) {
      edges {
        node {
          id
          name
          __typename
        }
        cursor
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
    id
  }
}

fragment IdleTimeDropdown_idleTimes on IdleTimeTypeEdge {
  node {
    id
    name
    isInternalTime
    disabled
  }
}

fragment LabelDropdownJS_labels on Label {
  color
  name
  id
  category {
    id
    name
  }
}

fragment PersonDropdown_persons on PersonTypeEdge {
  node {
    id
    fullName
    firstName
    lastName
    profilePictureId
    active
    client {
      id
    }
    role {
      name
      id
    }
  }
}

fragment PhasesDropdown_phases on PhaseTypeEdge {
  node {
    name
    id
  }
}

fragment ProjectContactDropdown_projects on ProjectTypeEdge {
  node {
    id
    projectPersons(first: 1000000, contactsOnly: true) {
      edges {
        node {
          id
          isContactPerson
          person {
            id
            firstName
            lastName
            profilePictureId
          }
        }
      }
    }
  }
}

fragment ProjectDropdown_projects on ProjectTypeEdge {
  node {
    id
    name
    projectColor
    companyProjectId
    customProjectId
    status
    ...DeprecatedProjectIndicatorJS_project
    manualProgressOnProjectEnabled
    manualProgressOnPhasesEnabled
    manualProgressOnTasksEnabled
  }
}

fragment ProjectPersonDropdown_persons on ProjectPersonTypeEdge {
  node {
    id
    role {
      name
      id
    }
    person {
      id
      firstName
      lastName
      profilePictureId
      role {
        name
        id
      }
    }
  }
}

fragment ProjectStatusColumnDropdown_columns on StatusColumnV2TypeEdge {
  node {
    order
    name
    id
    projectGroupStatusColumnId
  }
}

fragment RateCardDropdown_rateCards on RateCardTypeEdge {
  node {
    id
    name
    currency
    parentRateCardId
    disabled
  }
}

fragment RoleDropdown_roles on RoleTypeEdge {
  node {
    name
    id
  }
}

fragment SkillDropdown_company on Company {
  skillLevelsEnabled
  skillLevels {
    id
    level
    description
  }
  skills(first: 10000) {
    edges {
      node {
        id
        name
        category {
          id
          name
        }
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  skillCategories(first: 10000) {
    edges {
      node {
        id
        name
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment SkillLevelDropdown_company on Company {
  skillLevels {
    id
    level
    description
  }
}

fragment SprintDropdown_sprints on SprintTypeEdge {
  node {
    name
    id
    projectGroupSprintId
    isProjectGroupSprint
    endYear
    endMonth
    endDay
  }
}

fragment TeamDropdown_teams on TeamTypeEdge {
  node {
    name
    id
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "projectId",
    "type": "ID"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "groupId",
    "type": "String"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "programPrefix",
    "type": "String"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "fetchAllProjectPhases",
    "type": "Boolean!"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actualPersonId",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "name",
      "value": "new_filter"
    }
  ],
  "kind": "ScalarField",
  "name": "component",
  "storageKey": "component(name:\"new_filter\")"
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = [
  (v3/*: any*/)
],
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "Client",
  "kind": "LinkedField",
  "name": "client",
  "plural": false,
  "selections": (v4/*: any*/),
  "storageKey": null
},
v6 = {
  "kind": "Literal",
  "name": "first",
  "value": 1000000
},
v7 = [
  {
    "kind": "Literal",
    "name": "excludeRestricted",
    "value": true
  },
  (v6/*: any*/)
],
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectColor",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "companyProjectId",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "customProjectId",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "manualProgressOnProjectEnabled",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "manualProgressOnPhasesEnabled",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "manualProgressOnTasksEnabled",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "profilePictureId",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v22 = [
  (v6/*: any*/)
],
v23 = {
  "alias": null,
  "args": (v22/*: any*/),
  "concreteType": "StatusColumnV2TypeConnection",
  "kind": "LinkedField",
  "name": "statusColumnsV2",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "StatusColumnV2TypeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "StatusColumnV2",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "order",
              "storageKey": null
            },
            (v8/*: any*/),
            (v3/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "projectGroupStatusColumnId",
              "storageKey": null
            },
            (v19/*: any*/)
          ],
          "storageKey": null
        },
        (v20/*: any*/)
      ],
      "storageKey": null
    },
    (v21/*: any*/)
  ],
  "storageKey": "statusColumnsV2(first:1000000)"
},
v24 = {
  "alias": null,
  "args": null,
  "concreteType": "Role",
  "kind": "LinkedField",
  "name": "role",
  "plural": false,
  "selections": [
    (v8/*: any*/),
    (v3/*: any*/)
  ],
  "storageKey": null
},
v25 = [
  (v8/*: any*/),
  (v3/*: any*/),
  (v19/*: any*/)
],
v26 = {
  "alias": null,
  "args": (v22/*: any*/),
  "concreteType": "PhaseTypeConnection",
  "kind": "LinkedField",
  "name": "phases",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PhaseTypeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PhaseType",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": (v25/*: any*/),
          "storageKey": null
        },
        (v20/*: any*/)
      ],
      "storageKey": null
    },
    (v21/*: any*/)
  ],
  "storageKey": "phases(first:1000000)"
},
v27 = {
  "alias": null,
  "args": (v22/*: any*/),
  "concreteType": "SprintTypeConnection",
  "kind": "LinkedField",
  "name": "sprints",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SprintTypeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Sprint",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v8/*: any*/),
            (v3/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "projectGroupSprintId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isProjectGroupSprint",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endYear",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endMonth",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endDay",
              "storageKey": null
            },
            (v19/*: any*/)
          ],
          "storageKey": null
        },
        (v20/*: any*/)
      ],
      "storageKey": null
    },
    (v21/*: any*/)
  ],
  "storageKey": "sprints(first:1000000)"
},
v28 = {
  "alias": null,
  "args": (v22/*: any*/),
  "concreteType": "ProjectPersonTypeConnection",
  "kind": "LinkedField",
  "name": "projectPersons",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ProjectPersonTypeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ProjectPerson",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v3/*: any*/),
            (v24/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "Person",
              "kind": "LinkedField",
              "name": "person",
              "plural": false,
              "selections": [
                (v3/*: any*/),
                (v16/*: any*/),
                (v17/*: any*/),
                (v18/*: any*/),
                (v24/*: any*/)
              ],
              "storageKey": null
            },
            (v19/*: any*/)
          ],
          "storageKey": null
        },
        (v20/*: any*/)
      ],
      "storageKey": null
    },
    (v21/*: any*/)
  ],
  "storageKey": "projectPersons(first:1000000)"
},
v29 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 10000
  }
],
v30 = [
  (v3/*: any*/),
  (v8/*: any*/)
],
v31 = [
  (v3/*: any*/),
  (v8/*: any*/),
  (v19/*: any*/)
],
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "disabled",
  "storageKey": null
},
v33 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1000
  }
],
v34 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 100000
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FilterQueryContent_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "args": [
              {
                "kind": "Variable",
                "name": "fetchAllProjectPhases",
                "variableName": "fetchAllProjectPhases"
              },
              {
                "kind": "Variable",
                "name": "groupId",
                "variableName": "groupId"
              },
              {
                "kind": "Variable",
                "name": "programPrefix",
                "variableName": "programPrefix"
              },
              {
                "kind": "Variable",
                "name": "projectId",
                "variableName": "projectId"
              }
            ],
            "kind": "FragmentSpread",
            "name": "FilterQueryContent_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FilterQueryContent_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "FeatureFlag",
            "kind": "LinkedField",
            "name": "availableFeatureFlags",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "key",
                "storageKey": null
              },
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v7/*: any*/),
            "concreteType": "ProjectTypeConnection",
            "kind": "LinkedField",
            "name": "projects",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ProjectTypeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProjectType",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v8/*: any*/),
                      (v9/*: any*/),
                      (v10/*: any*/),
                      (v11/*: any*/),
                      (v12/*: any*/),
                      (v13/*: any*/),
                      (v14/*: any*/),
                      (v15/*: any*/),
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "contactsOnly",
                            "value": true
                          },
                          (v6/*: any*/)
                        ],
                        "concreteType": "ProjectPersonTypeConnection",
                        "kind": "LinkedField",
                        "name": "projectPersons",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ProjectPersonTypeEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ProjectPerson",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v3/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "isContactPerson",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Person",
                                    "kind": "LinkedField",
                                    "name": "person",
                                    "plural": false,
                                    "selections": [
                                      (v3/*: any*/),
                                      (v16/*: any*/),
                                      (v17/*: any*/),
                                      (v18/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "projectPersons(contactsOnly:true,first:1000000)"
                      },
                      (v19/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v20/*: any*/)
                ],
                "storageKey": null
              },
              (v21/*: any*/)
            ],
            "storageKey": "projects(excludeRestricted:true,first:1000000)"
          },
          {
            "alias": null,
            "args": (v7/*: any*/),
            "filters": [],
            "handle": "connection",
            "key": "FilterViewer_filters_projects",
            "kind": "LinkedHandle",
            "name": "projects"
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "internalId",
                "variableName": "projectId"
              }
            ],
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "demo",
                "storageKey": null
              },
              (v23/*: any*/),
              {
                "alias": null,
                "args": (v22/*: any*/),
                "filters": [],
                "handle": "connection",
                "key": "FilterViewer_filters_statusColumnsV2",
                "kind": "LinkedHandle",
                "name": "statusColumnsV2"
              },
              {
                "alias": null,
                "args": (v22/*: any*/),
                "concreteType": "ProjectPersonTypeConnection",
                "kind": "LinkedField",
                "name": "projectPersons",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProjectPersonTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProjectPerson",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v24/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Person",
                            "kind": "LinkedField",
                            "name": "person",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              (v16/*: any*/),
                              (v17/*: any*/),
                              (v18/*: any*/),
                              (v24/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "initials",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "profilePictureDefaultId",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v19/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v20/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v21/*: any*/)
                ],
                "storageKey": "projectPersons(first:1000000)"
              },
              {
                "alias": null,
                "args": (v22/*: any*/),
                "filters": [],
                "handle": "connection",
                "key": "FilterViewer_filters_projectPersons",
                "kind": "LinkedHandle",
                "name": "projectPersons"
              },
              (v26/*: any*/),
              {
                "alias": null,
                "args": (v22/*: any*/),
                "filters": [],
                "handle": "connection",
                "key": "FilterViewer_filters_phases",
                "kind": "LinkedHandle",
                "name": "phases"
              },
              (v27/*: any*/),
              {
                "alias": null,
                "args": (v22/*: any*/),
                "filters": [],
                "handle": "connection",
                "key": "FilterViewer_filters_sprints",
                "kind": "LinkedHandle",
                "name": "sprints"
              },
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "id",
                "variableName": "groupId"
              }
            ],
            "concreteType": "ProjectGroupType",
            "kind": "LinkedField",
            "name": "projectGroup",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v22/*: any*/),
                "concreteType": "ProjectTypeConnection",
                "kind": "LinkedField",
                "name": "projects",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProjectTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProjectType",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v8/*: any*/),
                          (v9/*: any*/),
                          (v10/*: any*/),
                          (v11/*: any*/),
                          (v12/*: any*/),
                          (v13/*: any*/),
                          (v14/*: any*/),
                          (v15/*: any*/),
                          (v23/*: any*/),
                          {
                            "alias": null,
                            "args": (v22/*: any*/),
                            "filters": [],
                            "handle": "connection",
                            "key": "FilterViewer_filters__project_group_projects_statusColumnsV2",
                            "kind": "LinkedHandle",
                            "name": "statusColumnsV2"
                          },
                          (v28/*: any*/),
                          {
                            "alias": null,
                            "args": (v22/*: any*/),
                            "filters": [],
                            "handle": "connection",
                            "key": "FilterViewer_filters_project_group_projects_projectPersons",
                            "kind": "LinkedHandle",
                            "name": "projectPersons"
                          },
                          (v26/*: any*/),
                          {
                            "alias": null,
                            "args": (v22/*: any*/),
                            "filters": null,
                            "handle": "connection",
                            "key": "FilterViewer_filters_project_group_phases",
                            "kind": "LinkedHandle",
                            "name": "phases"
                          },
                          (v27/*: any*/),
                          {
                            "alias": null,
                            "args": (v22/*: any*/),
                            "filters": null,
                            "handle": "connection",
                            "key": "FilterViewer_filters_project_group_sprints",
                            "kind": "LinkedHandle",
                            "name": "sprints"
                          },
                          (v19/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v20/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v21/*: any*/)
                ],
                "storageKey": "projects(first:1000000)"
              },
              {
                "alias": null,
                "args": (v22/*: any*/),
                "filters": [],
                "handle": "connection",
                "key": "FilterViewer_filters_project_group_projects",
                "kind": "LinkedHandle",
                "name": "projects"
              },
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "prefix",
                "variableName": "programPrefix"
              }
            ],
            "concreteType": "ProgramType",
            "kind": "LinkedField",
            "name": "program",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v22/*: any*/),
                "concreteType": "ProjectServiceProjectTypeConnection",
                "kind": "LinkedField",
                "name": "projects",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProjectServiceProjectTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProjectServiceProjectType",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "serviceCompanyId",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ProjectTypeConnection",
                            "kind": "LinkedField",
                            "name": "legacyProject",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ProjectTypeEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ProjectType",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v3/*: any*/),
                                      (v8/*: any*/),
                                      (v9/*: any*/),
                                      (v10/*: any*/),
                                      (v11/*: any*/),
                                      (v12/*: any*/),
                                      (v13/*: any*/),
                                      (v14/*: any*/),
                                      (v15/*: any*/),
                                      (v23/*: any*/),
                                      {
                                        "alias": null,
                                        "args": (v22/*: any*/),
                                        "filters": [],
                                        "handle": "connection",
                                        "key": "FilterViewer_filters_program_projects_statusColumnsV2",
                                        "kind": "LinkedHandle",
                                        "name": "statusColumnsV2"
                                      },
                                      (v28/*: any*/),
                                      {
                                        "alias": null,
                                        "args": (v22/*: any*/),
                                        "filters": [],
                                        "handle": "connection",
                                        "key": "FilterViewer_filters_program_projects_projectPersons",
                                        "kind": "LinkedHandle",
                                        "name": "projectPersons"
                                      },
                                      (v26/*: any*/),
                                      {
                                        "alias": null,
                                        "args": (v22/*: any*/),
                                        "filters": null,
                                        "handle": "connection",
                                        "key": "FilterViewer_filters_program_phases",
                                        "kind": "LinkedHandle",
                                        "name": "phases"
                                      },
                                      (v27/*: any*/),
                                      {
                                        "alias": null,
                                        "args": (v22/*: any*/),
                                        "filters": null,
                                        "handle": "connection",
                                        "key": "FilterViewer_filters_program_sprints",
                                        "kind": "LinkedHandle",
                                        "name": "sprints"
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v3/*: any*/),
                          (v19/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v20/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v21/*: any*/)
                ],
                "storageKey": "projects(first:1000000)"
              },
              {
                "alias": null,
                "args": (v22/*: any*/),
                "filters": [],
                "handle": "connection",
                "key": "FilterViewer_filters_program_projects",
                "kind": "LinkedHandle",
                "name": "projects"
              },
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "skillLevelsEnabled",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "SkillLevel",
                "kind": "LinkedField",
                "name": "skillLevels",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "level",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "description",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v29/*: any*/),
                "concreteType": "SkillTypeConnection",
                "kind": "LinkedField",
                "name": "skills",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SkillTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Skill",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v8/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "SkillCategory",
                            "kind": "LinkedField",
                            "name": "category",
                            "plural": false,
                            "selections": (v30/*: any*/),
                            "storageKey": null
                          },
                          (v19/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v20/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v21/*: any*/)
                ],
                "storageKey": "skills(first:10000)"
              },
              {
                "alias": null,
                "args": (v29/*: any*/),
                "filters": null,
                "handle": "connection",
                "key": "Company_skills",
                "kind": "LinkedHandle",
                "name": "skills"
              },
              {
                "alias": null,
                "args": (v29/*: any*/),
                "concreteType": "SkillCategoryTypeConnection",
                "kind": "LinkedField",
                "name": "skillCategories",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SkillCategoryTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SkillCategory",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": (v31/*: any*/),
                        "storageKey": null
                      },
                      (v20/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v21/*: any*/)
                ],
                "storageKey": "skillCategories(first:10000)"
              },
              {
                "alias": null,
                "args": (v29/*: any*/),
                "filters": null,
                "handle": "connection",
                "key": "Company_skillCategories",
                "kind": "LinkedHandle",
                "name": "skillCategories"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Module",
                "kind": "LinkedField",
                "name": "modules",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "moduleType",
                    "storageKey": null
                  },
                  (v3/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v22/*: any*/),
                "concreteType": "RateCardTypeConnection",
                "kind": "LinkedField",
                "name": "rateCards",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RateCardTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "RateCard",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v8/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "currency",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "parentRateCardId",
                            "storageKey": null
                          },
                          (v32/*: any*/),
                          (v19/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v20/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v21/*: any*/)
                ],
                "storageKey": "rateCards(first:1000000)"
              },
              {
                "alias": null,
                "args": (v22/*: any*/),
                "filters": [],
                "handle": "connection",
                "key": "FilterViewer_filters_company_rateCards",
                "kind": "LinkedHandle",
                "name": "rateCards"
              },
              {
                "alias": null,
                "args": (v22/*: any*/),
                "concreteType": "PersonTypeConnection",
                "kind": "LinkedField",
                "name": "allPersons",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PersonTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Person",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "fullName",
                            "storageKey": null
                          },
                          (v16/*: any*/),
                          (v17/*: any*/),
                          (v18/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "active",
                            "storageKey": null
                          },
                          (v5/*: any*/),
                          (v24/*: any*/),
                          (v19/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v20/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v21/*: any*/)
                ],
                "storageKey": "allPersons(first:1000000)"
              },
              {
                "alias": null,
                "args": (v22/*: any*/),
                "filters": [],
                "handle": "connection",
                "key": "FilterViewer_filters_company_allPersons",
                "kind": "LinkedHandle",
                "name": "allPersons"
              },
              {
                "alias": null,
                "args": (v22/*: any*/),
                "concreteType": "TeamTypeConnection",
                "kind": "LinkedField",
                "name": "teams",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TeamTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Team",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v8/*: any*/),
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": (v33/*: any*/),
                            "concreteType": "TeamPersonTypeConnection",
                            "kind": "LinkedField",
                            "name": "teamPersons",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "TeamPersonTypeEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "TeamPerson",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v3/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Person",
                                        "kind": "LinkedField",
                                        "name": "person",
                                        "plural": false,
                                        "selections": (v4/*: any*/),
                                        "storageKey": null
                                      },
                                      (v19/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v20/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v21/*: any*/)
                            ],
                            "storageKey": "teamPersons(first:1000)"
                          },
                          {
                            "alias": null,
                            "args": (v33/*: any*/),
                            "filters": [],
                            "handle": "connection",
                            "key": "FilterViewer_filters_company_teams_teamPersons",
                            "kind": "LinkedHandle",
                            "name": "teamPersons"
                          },
                          (v19/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v20/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v21/*: any*/)
                ],
                "storageKey": "teams(first:1000000)"
              },
              {
                "alias": null,
                "args": (v22/*: any*/),
                "filters": [],
                "handle": "connection",
                "key": "FilterViewer_filters_company_teams",
                "kind": "LinkedHandle",
                "name": "teams"
              },
              {
                "alias": null,
                "args": (v22/*: any*/),
                "concreteType": "ClientTypeConnection",
                "kind": "LinkedField",
                "name": "clients",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ClientTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Client",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v8/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "logoId",
                            "storageKey": null
                          },
                          (v19/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v20/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v21/*: any*/)
                ],
                "storageKey": "clients(first:1000000)"
              },
              {
                "alias": null,
                "args": (v22/*: any*/),
                "filters": [],
                "handle": "connection",
                "key": "FilterViewer_filters_company_clients",
                "kind": "LinkedHandle",
                "name": "clients"
              },
              {
                "alias": null,
                "args": (v22/*: any*/),
                "concreteType": "LabelTypeConnection",
                "kind": "LinkedField",
                "name": "labels",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LabelTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Label",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v8/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "LabelCategory",
                            "kind": "LinkedField",
                            "name": "category",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              (v8/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "allowOnPeople",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "allowOnProjects",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "allowOnTasks",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "color",
                            "storageKey": null
                          },
                          (v19/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v20/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v21/*: any*/)
                ],
                "storageKey": "labels(first:1000000)"
              },
              {
                "alias": null,
                "args": (v22/*: any*/),
                "filters": [],
                "handle": "connection",
                "key": "FilterViewer_filters_company_labels",
                "kind": "LinkedHandle",
                "name": "labels"
              },
              {
                "alias": null,
                "args": (v22/*: any*/),
                "concreteType": "RoleTypeConnection",
                "kind": "LinkedField",
                "name": "roles",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RoleTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Role",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": (v25/*: any*/),
                        "storageKey": null
                      },
                      (v20/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v21/*: any*/)
                ],
                "storageKey": "roles(first:1000000)"
              },
              {
                "alias": null,
                "args": (v22/*: any*/),
                "filters": [],
                "handle": "connection",
                "key": "FilterViewer_filters_company_roles",
                "kind": "LinkedHandle",
                "name": "roles"
              },
              {
                "alias": null,
                "args": (v22/*: any*/),
                "concreteType": "IdleTimeTypeConnection",
                "kind": "LinkedField",
                "name": "idleTimes",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "IdleTimeTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "IdleTime",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v8/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isInternalTime",
                            "storageKey": null
                          },
                          (v32/*: any*/),
                          (v19/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v20/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v21/*: any*/)
                ],
                "storageKey": "idleTimes(first:1000000)"
              },
              {
                "alias": null,
                "args": (v22/*: any*/),
                "filters": [],
                "handle": "connection",
                "key": "FilterViewer_filters_company_idleTimes",
                "kind": "LinkedHandle",
                "name": "idleTimes"
              },
              {
                "alias": null,
                "args": (v34/*: any*/),
                "concreteType": "DepartmentTypeConnection",
                "kind": "LinkedField",
                "name": "departments",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "DepartmentTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "DepartmentType",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": (v30/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "departments(first:100000)"
              },
              {
                "alias": null,
                "args": (v33/*: any*/),
                "concreteType": "PriorityLevelTypeConnection",
                "kind": "LinkedField",
                "name": "priorityLevels",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PriorityLevelTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PriorityLevel",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v8/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "weight",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "priorityLevels(first:1000)"
              },
              {
                "alias": null,
                "args": (v34/*: any*/),
                "concreteType": "ProjectServiceProgramTypeConnection",
                "kind": "LinkedField",
                "name": "programs",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProjectServiceProgramTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProgramType",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": (v30/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "programs(first:100000)"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "BillFrom",
                "kind": "LinkedField",
                "name": "billFroms",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "integration",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": (v29/*: any*/),
                    "concreteType": "BillToTypeConnection",
                    "kind": "LinkedField",
                    "name": "billTos",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "BillToTypeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "BillTo",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": (v31/*: any*/),
                            "storageKey": null
                          },
                          (v20/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v21/*: any*/)
                    ],
                    "storageKey": "billTos(first:10000)"
                  },
                  {
                    "alias": null,
                    "args": (v29/*: any*/),
                    "filters": [],
                    "handle": "connection",
                    "key": "BillFrom_billTos",
                    "kind": "LinkedHandle",
                    "name": "billTos"
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v29/*: any*/),
                "concreteType": "ExpenseCategoryTypeConnection",
                "kind": "LinkedField",
                "name": "expenseCategories",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ExpenseCategoryTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ExpenseCategory",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": (v31/*: any*/),
                        "storageKey": null
                      },
                      (v20/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v21/*: any*/)
                ],
                "storageKey": "expenseCategories(first:10000)"
              },
              {
                "alias": null,
                "args": (v29/*: any*/),
                "filters": null,
                "handle": "connection",
                "key": "Company_expenseCategories",
                "kind": "LinkedHandle",
                "name": "expenseCategories"
              },
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          (v3/*: any*/),
          {
            "condition": "fetchAllProjectPhases",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PhaseTypeConnection",
                "kind": "LinkedField",
                "name": "phases",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PhaseTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PhaseType",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v8/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "projectId",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "FilterQueryContent_Query",
    "operationKind": "query",
    "text": "query FilterQueryContent_Query(\n  $projectId: ID\n  $groupId: String\n  $programPrefix: String\n  $fetchAllProjectPhases: Boolean!\n) {\n  viewer {\n    actualPersonId\n    component(name: \"new_filter\")\n    ...FilterQueryContent_viewer_ThpMZ\n    id\n  }\n}\n\nfragment AllPhasesDropdown_phases on PhaseTypeEdge {\n  node {\n    id\n    name\n    projectId\n  }\n}\n\nfragment AllPhasesDropdown_projects on ProjectTypeEdge {\n  node {\n    id\n    name\n    projectColor\n    companyProjectId\n    status\n  }\n}\n\nfragment ClientDropdown_clients on ClientTypeEdge {\n  node {\n    id\n    name\n    logoId\n  }\n}\n\nfragment DepartmentDropdown_departments on DepartmentTypeEdge {\n  node {\n    id\n    name\n  }\n}\n\nfragment DeprecatedProjectIndicatorJS_project on ProjectType {\n  name\n  companyProjectId\n  customProjectId\n  projectColor\n}\n\nfragment FilterQueryContent_viewer_ThpMZ on Viewer {\n  client {\n    id\n  }\n  availableFeatureFlags {\n    key\n    id\n  }\n  projects(first: 1000000, excludeRestricted: true) {\n    edges {\n      ...ProjectDropdown_projects\n      ...ProjectContactDropdown_projects\n      ...AllPhasesDropdown_projects @include(if: $fetchAllProjectPhases)\n      node {\n        id\n        name\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  phases @include(if: $fetchAllProjectPhases) {\n    edges {\n      ...AllPhasesDropdown_phases @include(if: $fetchAllProjectPhases)\n      node {\n        id\n        name\n        projectId\n      }\n    }\n  }\n  project(internalId: $projectId) {\n    demo\n    statusColumnsV2(first: 1000000) {\n      edges {\n        ...ProjectStatusColumnDropdown_columns\n        node {\n          id\n          name\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n    projectPersons(first: 1000000) {\n      edges {\n        ...ProjectPersonDropdown_persons\n        node {\n          person {\n            id\n            initials\n            firstName\n            lastName\n            profilePictureId\n            profilePictureDefaultId\n          }\n          id\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n    phases(first: 1000000) {\n      edges {\n        ...PhasesDropdown_phases\n        node {\n          id\n          name\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n    sprints(first: 1000000) {\n      edges {\n        ...SprintDropdown_sprints\n        node {\n          id\n          name\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n    id\n  }\n  projectGroup(id: $groupId) {\n    projects(first: 1000000) {\n      edges {\n        ...ProjectDropdown_projects\n        node {\n          id\n          name\n          companyProjectId\n          statusColumnsV2(first: 1000000) {\n            edges {\n              ...ProjectStatusColumnDropdown_columns\n              node {\n                id\n                name\n                projectGroupStatusColumnId\n                __typename\n              }\n              cursor\n            }\n            pageInfo {\n              endCursor\n              hasNextPage\n            }\n          }\n          projectPersons(first: 1000000) {\n            edges {\n              ...ProjectPersonDropdown_persons\n              node {\n                person {\n                  id\n                  firstName\n                  lastName\n                }\n                id\n                __typename\n              }\n              cursor\n            }\n            pageInfo {\n              endCursor\n              hasNextPage\n            }\n          }\n          phases(first: 1000000) {\n            edges {\n              ...PhasesDropdown_phases\n              node {\n                id\n                name\n                __typename\n              }\n              cursor\n            }\n            pageInfo {\n              endCursor\n              hasNextPage\n            }\n          }\n          sprints(first: 1000000) {\n            edges {\n              ...SprintDropdown_sprints\n              node {\n                id\n                name\n                projectGroupSprintId\n                __typename\n              }\n              cursor\n            }\n            pageInfo {\n              endCursor\n              hasNextPage\n            }\n          }\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n    id\n  }\n  program(prefix: $programPrefix) {\n    projects(first: 1000000) {\n      edges {\n        node {\n          serviceCompanyId\n          legacyProject {\n            edges {\n              ...ProjectDropdown_projects\n              node {\n                id\n                name\n                companyProjectId\n                statusColumnsV2(first: 1000000) {\n                  edges {\n                    ...ProjectStatusColumnDropdown_columns\n                    node {\n                      id\n                      name\n                      projectGroupStatusColumnId\n                      __typename\n                    }\n                    cursor\n                  }\n                  pageInfo {\n                    endCursor\n                    hasNextPage\n                  }\n                }\n                projectPersons(first: 1000000) {\n                  edges {\n                    ...ProjectPersonDropdown_persons\n                    node {\n                      person {\n                        id\n                        firstName\n                        lastName\n                      }\n                      id\n                      __typename\n                    }\n                    cursor\n                  }\n                  pageInfo {\n                    endCursor\n                    hasNextPage\n                  }\n                }\n                phases(first: 1000000) {\n                  edges {\n                    ...PhasesDropdown_phases\n                    node {\n                      id\n                      name\n                      __typename\n                    }\n                    cursor\n                  }\n                  pageInfo {\n                    endCursor\n                    hasNextPage\n                  }\n                }\n                sprints(first: 1000000) {\n                  edges {\n                    ...SprintDropdown_sprints\n                    node {\n                      id\n                      name\n                      projectGroupSprintId\n                      __typename\n                    }\n                    cursor\n                  }\n                  pageInfo {\n                    endCursor\n                    hasNextPage\n                  }\n                }\n              }\n            }\n          }\n          id\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n    id\n  }\n  company {\n    skillLevelsEnabled\n    skillLevels {\n      id\n      level\n      description\n    }\n    ...SkillDropdown_company\n    skills(first: 10000) {\n      edges {\n        node {\n          id\n          name\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n    ...SkillLevelDropdown_company\n    modules {\n      moduleType\n      id\n    }\n    rateCards(first: 1000000) {\n      edges {\n        ...RateCardDropdown_rateCards\n        node {\n          id\n          name\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n    allPersons(first: 1000000) {\n      edges {\n        ...PersonDropdown_persons\n        node {\n          id\n          firstName\n          lastName\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n    teams(first: 1000000) {\n      edges {\n        ...TeamDropdown_teams\n        node {\n          id\n          name\n          teamPersons(first: 1000) {\n            edges {\n              node {\n                id\n                person {\n                  id\n                }\n                __typename\n              }\n              cursor\n            }\n            pageInfo {\n              endCursor\n              hasNextPage\n            }\n          }\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n    clients(first: 1000000) {\n      edges {\n        ...ClientDropdown_clients\n        node {\n          id\n          name\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n    labels(first: 1000000) {\n      edges {\n        node {\n          id\n          name\n          category {\n            id\n            name\n            allowOnPeople\n            allowOnProjects\n            allowOnTasks\n          }\n          ...LabelDropdownJS_labels\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n    roles(first: 1000000) {\n      edges {\n        ...RoleDropdown_roles\n        node {\n          id\n          name\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n    idleTimes(first: 1000000) {\n      edges {\n        ...IdleTimeDropdown_idleTimes\n        node {\n          id\n          name\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n    departments(first: 100000) {\n      edges {\n        ...DepartmentDropdown_departments\n        node {\n          id\n          name\n        }\n      }\n    }\n    priorityLevels(first: 1000) {\n      edges {\n        node {\n          id\n          name\n          weight\n        }\n      }\n    }\n    programs(first: 100000) {\n      edges {\n        node {\n          id\n          name\n        }\n      }\n    }\n    billFroms {\n      id\n      name\n      integration\n      billTos(first: 10000) {\n        edges {\n          node {\n            id\n            name\n            __typename\n          }\n          cursor\n        }\n        pageInfo {\n          endCursor\n          hasNextPage\n        }\n      }\n    }\n    expenseCategories(first: 10000) {\n      edges {\n        node {\n          id\n          name\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n    id\n  }\n}\n\nfragment IdleTimeDropdown_idleTimes on IdleTimeTypeEdge {\n  node {\n    id\n    name\n    isInternalTime\n    disabled\n  }\n}\n\nfragment LabelDropdownJS_labels on Label {\n  color\n  name\n  id\n  category {\n    id\n    name\n  }\n}\n\nfragment PersonDropdown_persons on PersonTypeEdge {\n  node {\n    id\n    fullName\n    firstName\n    lastName\n    profilePictureId\n    active\n    client {\n      id\n    }\n    role {\n      name\n      id\n    }\n  }\n}\n\nfragment PhasesDropdown_phases on PhaseTypeEdge {\n  node {\n    name\n    id\n  }\n}\n\nfragment ProjectContactDropdown_projects on ProjectTypeEdge {\n  node {\n    id\n    projectPersons(first: 1000000, contactsOnly: true) {\n      edges {\n        node {\n          id\n          isContactPerson\n          person {\n            id\n            firstName\n            lastName\n            profilePictureId\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment ProjectDropdown_projects on ProjectTypeEdge {\n  node {\n    id\n    name\n    projectColor\n    companyProjectId\n    customProjectId\n    status\n    ...DeprecatedProjectIndicatorJS_project\n    manualProgressOnProjectEnabled\n    manualProgressOnPhasesEnabled\n    manualProgressOnTasksEnabled\n  }\n}\n\nfragment ProjectPersonDropdown_persons on ProjectPersonTypeEdge {\n  node {\n    id\n    role {\n      name\n      id\n    }\n    person {\n      id\n      firstName\n      lastName\n      profilePictureId\n      role {\n        name\n        id\n      }\n    }\n  }\n}\n\nfragment ProjectStatusColumnDropdown_columns on StatusColumnV2TypeEdge {\n  node {\n    order\n    name\n    id\n    projectGroupStatusColumnId\n  }\n}\n\nfragment RateCardDropdown_rateCards on RateCardTypeEdge {\n  node {\n    id\n    name\n    currency\n    parentRateCardId\n    disabled\n  }\n}\n\nfragment RoleDropdown_roles on RoleTypeEdge {\n  node {\n    name\n    id\n  }\n}\n\nfragment SkillDropdown_company on Company {\n  skillLevelsEnabled\n  skillLevels {\n    id\n    level\n    description\n  }\n  skills(first: 10000) {\n    edges {\n      node {\n        id\n        name\n        category {\n          id\n          name\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  skillCategories(first: 10000) {\n    edges {\n      node {\n        id\n        name\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment SkillLevelDropdown_company on Company {\n  skillLevels {\n    id\n    level\n    description\n  }\n}\n\nfragment SprintDropdown_sprints on SprintTypeEdge {\n  node {\n    name\n    id\n    projectGroupSprintId\n    isProjectGroupSprint\n    endYear\n    endMonth\n    endDay\n  }\n}\n\nfragment TeamDropdown_teams on TeamTypeEdge {\n  node {\n    name\n    id\n  }\n}\n"
  }
};
})();
(node as any).hash = '8d35b7b8d98fa7b3b3d091078e30e340';
export default node;
